import React from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import { FlowStepData } from "../../../rule-engine-core/Flow/Steps/FlowStepData";
import {
    FlowStepOutputInstructions,
    FlowStepOutputInstructionType,
} from "../../../rule-engine-core/Flow/Structure/FlowStepOutputInstructions";
import { FlowEditContext } from "../../FlowEditContext";
import { ErrorFlowIcon } from "../../../CommonUI/Icon/ErrorFlowIcon";
import { ErrorIcon } from "../../../CommonUI/Icon/ErrorIcon";
import { NoDataIcon } from "../../../CommonUI/Icon/NoDataIcon";
import { EndFlowIcon } from "../../../CommonUI/Icon/EndFlowIcon";
import { EndIcon } from "../../../CommonUI/Icon/EndIcon";
import { FlowConstants } from "../../../rule-engine-core/Flow/Utilities/FlowConstants";
import { FlowUtilities } from "../../../rule-engine-core/Flow/Utilities/FlowUtilities";

export const FlowSummaryDiv = styled.div<{ notEndAlign?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${(props) => !props.notEndAlign && `justify-content: flex-end;`}
    cursor: pointer;
    position: relative;

    label {
        position: absolute;
        top: 0;
        right: 100%;
        white-space: pre;
    }

    .step-path-name-error {
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 140%;
        color: ${FlowConstants.STEP_PATH_ERROR_COLOR};
        margin-left: 0px;

        text-transform: capitalize;
    }

    .step-path-error-message {
        display: flex;
        margin-left: 4px;
    }

    .step-path-name-end {
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 140%;
        color: ${FlowConstants.STEP_PATH_END_COLOR};
        margin-left: 0px;

        text-transform: capitalize;

        cursor: pointer;
    }
`;

const ExtraIconDiv = styled.div`
    position: absolute;
    left: 100%;
    top: 0;
    display: flex;
`;

interface IRegularStepInstruction {
    editContext: FlowEditContext;
    instruction: FlowStepOutputInstructions;
    hideLabel?: boolean;
    step?: FlowStepData;
    hiddenStepName?: string;
    showHiddenBranch?: boolean;
}

export const RenderStepInstruction: React.FC<IRegularStepInstruction> = (props: IRegularStepInstruction) => {
    const step = props.step ? props.step : (props.editContext.flow.find(props.instruction.stepId) as FlowStepData);

    const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (step) {
            props.editContext.setSelectedStepStrategy(event.currentTarget, step as FlowStepData);
        }
    };

    if (!step) return null;

    let tooltipLabel =
        props.hiddenStepName && FlowUtilities.IsEndStep(step!) ? props.hiddenStepName : props.instruction.pathName;
    let label = `${tooltipLabel.slice(0, FlowConstants.MAX_CHARS_STEP_PATH_LABEL)}${
        tooltipLabel.length > FlowConstants.MAX_CHARS_STEP_PATH_LABEL ? "..." : ""
    }`;

    if (props.instruction.strategy === FlowStepOutputInstructionType.THROW_EXCEPTION) {
        return (
            <Tooltip title={tooltipLabel}>
                <FlowSummaryDiv onClick={onClick}>
                    {!props.hideLabel && <label className="step-path-name-error">{label}</label>}
                    <NoDataIcon />
                    <ExtraIconDiv id={props.instruction.getElementId()}>
                        <ErrorFlowIcon />
                        <div className="step-path-error-message">
                            <ErrorIcon />
                        </div>
                    </ExtraIconDiv>
                </FlowSummaryDiv>
            </Tooltip>
        );
    }
    if (props.instruction.strategy === FlowStepOutputInstructionType.END_FLOW) {
        return (
            <Tooltip title={tooltipLabel}>
                <FlowSummaryDiv onClick={onClick}>
                    {!props.hideLabel && <label className="step-path-name-end">{label}</label>}
                    <EndIcon />
                    <ExtraIconDiv id={props.instruction.getElementId()}>
                        <EndFlowIcon />
                    </ExtraIconDiv>
                </FlowSummaryDiv>
            </Tooltip>
        );
    }

    if (props.instruction.strategy === FlowStepOutputInstructionType.BRANCH) {
        if (FlowUtilities.IsEndStep(step!) && !props.showHiddenBranch) {
            return null;
        }
        return (
            <Tooltip title={tooltipLabel}>
                <FlowSummaryDiv
                    notEndAlign
                    onClick={onClick}
                >
                    {!props.hideLabel && <label className="step-path-name-end">{label}</label>}
                    <div id={props.instruction.getElementId()} />
                </FlowSummaryDiv>
            </Tooltip>
        );
    }

    return null;
};
